import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'preact/hooks';
import { newsRepo } from '@/data/repositories/news-repo';
import type { NewsItem } from '@/domain/types';

const STORAGE_KEY = 'boostly.lastSeenNewsId';

function getLastSeenId(): number {
  try { return Number(localStorage.getItem(STORAGE_KEY)) || 0; }
  catch { return 0; }
}

export function useUnseenNews() {
  const q = useQuery({ queryKey: ['news'], queryFn: newsRepo.latest, staleTime: 5 * 60_000 });
  const lastSeen = getLastSeenId();
  const items = q.data ?? [];
  const unseenCount = items.filter(it => (it.id ?? 0) > lastSeen).length;
  return { unseenCount, hasNew: unseenCount > 0 };
}

export function useMarkNewsSeen() {
  const qc = useQueryClient();
  return useCallback(() => {
    const items = qc.getQueryData<NewsItem[]>(['news']) ?? [];
    const maxId = items.reduce((max, it) => Math.max(max, it.id ?? 0), 0);
    if (maxId > 0) {
      try { localStorage.setItem(STORAGE_KEY, String(maxId)); } catch {}
    }
  }, [qc]);
}
